import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";
import { useParams } from "react-router-dom";

import "./C29FuelConsumptionSplit.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, c29SectionFormFields } from "../../Constants";
import FormField from "../../../../../common/form/Form";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const C29FuelConsumptionSplit = forwardRef(({ c29FuelSplitMethod,vesselMstId, refetchMonitoringData, allocationMethods }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    const { dirtyFields } = formState;
    const isC29Dirty = !!(dirtyFields?.c29 && Object.keys(dirtyFields.c29).length > 0);

    useEffect(() => {
        if (c29FuelSplitMethod) {
            reset(prev => ({ ...prev, c29: c29FuelSplitMethod }));
        }
    }, [c29FuelSplitMethod, reset]);

    AutoSave(ref, [], async () => {
        if (!isC29Dirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c29");
        const payload = {
            ...c29SectionFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const c29FuelConsumptionSplits = await callApi({
                method: "POST",
                url: API_ROUTES.C29(vesselMstId),
                data: payload,
            });
            if (c29FuelConsumptionSplits?.isSuccess) {
                emitToasterMsg("success", "Table C.2.9", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c29: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.2.9", c29FuelConsumptionSplits?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.2.9", error.errorMessage);
        }
    };

    const getAllocationOptions = [
        { label: "Select method", value: "" },
        ...allocationMethods?.map((item) => ({
            label: item.value,
            value: item.code,
        })),
    ];

    return (
        <div className="c29-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of method</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Determining the split of fuel consumption into freight and passenger part
                    </h6>
                </MDBCol>
            </MDBRow>

            {c29SectionFormFields.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        {type === "dropdown" ? (
                            <FormField
                                name={`c29.${name}`}
                                type="dropdown"
                                options={getAllocationOptions}
                            />
                        ) : (
                            <Controller
                                name={`c29.${name}`}
                                control={control}
                                render={({ field }) => (
                                    <TextArea
                                        id={`c29_${name}`}
                                        className="textarea-resize"
                                        value={field.value || ""}
                                        onChange={field.onChange}
                                        placeholder=""
                                        maxLength={maxLength}
                                        rows={1}
                                    />
                                )}
                            />
                        )}
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c29_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isC29Dirty}
                >
                    Save
                </Button>
            </div>
        </div>
    );
});

export default C29FuelConsumptionSplit;
